const zh = {
    '/': {
        title: '{brand} | 体育博彩、真人娱乐场 & 即时提款',
        description: '在{brand}玩老虎机、真人娱乐场并参与体育博彩。支持即时提款、可验证公平游戏和24/7支持的加密货币赌场。'
    },
    '/casino': {
        title: '在线娱乐场 | 老虎机、21点 & 真人荷官 | {brand}',
        description: '在{brand}玩老虎机、21点、轮盘 & 真人荷官。数百种游戏，快速加密货币存款 & 24/7即时提款。'
    },
    '/sports': {
        title: '在线体育博彩 | 加密货币体育投注 & 赔率 | {brand}',
        description: '在{brand}进行体育博彩。足球、篮球等具有竞争力的赔率。现场投注、安全的加密货币下注 & 快速支付。'
    },
    '/livecasino': {
        title: '真人娱乐场 | 21点、轮盘 & 真人荷官 | {brand}',
        description: '在{brand}玩21点、轮盘 & 真人娱乐场游戏。真实荷官，高清直播 & 24/7丰富真人桌台。'
    },
    '/slots': {
        title: '在线老虎机 | 海量娱乐场老虎机 | {brand}',
        description: '在{brand}旋转海量老虎机合集。经典水果机、视频老虎机 & 累积奖金，均可使用加密货币游玩。'
    },
    '/vip': {
        title: 'VIP计划 | 专属奖励 & 福利 | {brand}',
        description: '{brand}的VIP计划：专属奖励、个性化奖金和优先支持。为忠实玩家量身定制的特权。'
    },
    '/welcome-offer': {
        title: '欢迎优惠 | 加密货币娱乐场 | {brand}',
        description: '了解{brand}的欢迎优惠。使用加密货币开始游戏，享受新玩家专属福利。'
    },
    '/referral': {
        title: '推荐计划 | 赚取奖励 | {brand}',
        description: '邀请朋友加入{brand}，当他们注册并满足条件时即可赚取奖励。分享您的推荐链接，开始赚取。'
    },
    '/promotion-page': {
        title: '促销活动 | 奖金 & 特别优惠 | {brand}',
        description: '浏览{brand}所有活跃促销。加密货币玩家专享的奖金、免费旋转和特别优惠。'
    },
    '/hotslots': {
        title: '热门老虎机 | 热门娱乐场老虎机 | {brand}',
        description: '在{brand}玩最受欢迎的老虎机。支持加密货币的热门老虎机一应俱全。'
    },
    '/newgames': {
        title: '新游戏 | 最新娱乐场游戏 | {brand}',
        description: '探索{brand}最新的娱乐场游戏。新老虎机、真人游戏和桌游不断上线。'
    },
    '/populargames': {
        title: '热门游戏 | 最受欢迎娱乐场游戏 | {brand}',
        description: '{brand}最受欢迎的娱乐场游戏。从老虎机到真人游戏，全部支持加密货币。'
    },
    '/gameshows': {
        title: '游戏节目 | 真人游戏节目娱乐场 | {brand}',
        description: '在{brand}享受真人游戏节目。真实主持人现场互动，独特游戏玩法，丰厚奖励。'
    },
    '/table_games': {
        title: '桌游 | 21点、轮盘 & 百家乐 | {brand}',
        description: '在{brand}玩21点、轮盘、百家乐等桌游。全部支持加密货币游玩。'
    },
    '/hotlive': {
        title: '热门真人娱乐场 | 热门真人游戏 | {brand}',
        description: '{brand}最受欢迎的真人娱乐场游戏。与真实荷官实时互动游戏。'
    },
    '/featurebuyin': {
        title: '特购功能老虎机 | 直购奖励轮老虎机 | {brand}',
        description: '在{brand}玩支持购买特购功能的老虎机。直接进入奖励轮，无需等待触发。'
    },
    '/originals': {
        title: '原创娱乐场游戏 | 独家原创游戏 | {brand}',
        description: '在{brand}畅玩独家原创游戏。这些独一无二的自研游戏，在其他任何地方都找不到，为您带来无与伦比的娱乐场体验。'
    },
    '/providers': {
        title: '游戏提供商 | 合作工作室 & 软件 | {brand}',
        description: '探索{brand}的所有游戏提供商。我们与顶级工作室合作，为您提供多样化的高品质加密货币娱乐场游戏库。'
    },
    '/about-us': {
        title: '关于我们 | 了解更多关于 {brand}',
        description: '了解{brand} - 领先的加密货币娱乐场 & 体育博彩平台。致力于提供安全、公平 & 刺激的博彩体验及即时加密货币提款服务。'
    },
    '/affiliate': {
        title: '联盟计划 | 与 {brand} 共赚加密货币',
        description: '成为{brand}的合作伙伴，推广我们的加密货币娱乐场并赚取佣金。有竞争力的佣金比例、实时追踪及专属联盟支持。'
    },
    '/faq': {
        title: '常见问题 | FAQ | {brand}',
        description: '查找关于{brand}常见问题的解答。浏览我们的FAQ，获取有关账户、支付、奖金 & 娱乐场游戏的帮助。'
    },
    '/aml-policy': {
        title: 'AML政策 | {brand}反洗钱声明',
        description: '{brand}的AML政策确保安全可信的环境。了解我们防止平台上非法活动的相关措施。'
    },
    '/bonus-terms': {
        title: '奖金条款与条件 | {brand}优惠活动',
        description: '阅读{brand}娱乐场奖金 & 优惠活动的规则。了解如何领取、使用 & 提取奖金奖励。'
    },
    '/complaints-and-arbitration': {
        title: '投诉与仲裁 | {brand}玩家支持',
        description: '查找{brand}的投诉 & 争议解决流程。我们确保公平对待，迅速透明地解决玩家问题。'
    },
    '/fairness': {
        title: '可验证公平游戏 | {brand}公平性保障',
        description: '{brand}采用可验证公平技术，确保每个游戏结果均可验证、透明 & 完全随机。'
    },
    '/kyc-policy': {
        title: 'KYC政策 | {brand}客户身份验证',
        description: '{brand}的KYC政策概述了我们的身份验证流程。了解我们如何保护玩家并维护安全的游戏环境。'
    },
    '/payment-policy': {
        title: '支付政策 | 加密货币存取款 | {brand}',
        description: '{brand}接受加密货币存款 & 提款。阅读我们的支付政策，了解交易限额、支持的币种 & 处理时间。'
    },
    '/privacy-policy': {
        title: '隐私政策 | {brand}数据保护',
        description: '{brand}的隐私政策。了解我们如何在加密货币娱乐场平台上收集、使用 & 保护您的个人数据。'
    },
    '/responsible-gaming': {
        title: '负责任博彩 | 在 {brand} 安全游玩',
        description: '{brand}致力于负责任博彩。使用工具 & 资源管理您的游戏习惯，享受安全健康的游戏体验。'
    },
    '/terms-of-service': {
        title: '服务条款 | {brand}',
        description: '查阅规范您使用{brand}的条款与条件。了解作为玩家的权利和责任。'
    },
    '/terms-sports': {
        title: '体育博彩条款与条件 | {brand}',
        description: '{brand}的体育博彩条款与条件。有关下注规则、奖金支付 & 平台体育博彩使用的相关规定。'
    }
};
export default zh;
